module.exports = __webpack_public_path__ + "img/pic-ClaraZhou.4c6827fc.png";